import React from 'react'
import LeftSideBar from '../../../Components/Common/LeftSideBar'
import Footer from '../../../Components/Common/Footer'
import TopBar from '../../../Components/Common/TopBar'
import PageHeader from '../../../Components/Common/PageHeader'
import functions from '../../../utils/functions'
import RightSideBar from '../../../Components/Common/RightSideBar'
import ConfigMenu from '../../../Components/ConfigMenu'
import ajax from '../../../utils/ajax'
import ActivityLoader from '../../../Components/Common/ActivityLoader'
import WarnDelete from '../../../Components/WarnDelete'
import $ from 'jquery';
import Toast from '../../../Components/Common/Toast'
import ConfigurationContext, { ConfigurationConsumer } from '../../../Context/ConfigurationContext'
import dictionary from '../../../utils/dictionary'
import NoContent from '../../../Components/Common/NoContent'
import TableHeader from '../../../Components/Common/TableHeader'
import PopImportBranches from '../../../Components/PopImportBranches'
// const eformats = dictionary._exportBtnFormats
const eformats = ['excel', 'pdf', 'csv', 'print']




class ConfigBranch extends React.Component {
    static contextType = ConfigurationContext;
    state = {
        userId: functions.sessionGuard(),
        branchList: false,
        branchId: false,
        branchRecord: false,
        toast: '',

        modal: false,
    }


    onClickImportBranches = () => {
        const { getBranches } = this.context;
        this.setState({
            model: false
        }, () => {
            this.setState({
                model: <PopImportBranches
                    refresh={getBranches}
                />
            }, () => functions.openPopup('modal_import_branches'))

        })
    }

    buttons = () => {
        return (
            <>
                <button className="btn ripple btn-success" onClick={this.onClickAdd}>
                    <i className="fe fe-plus-circle mr-1"></i> Add
                </button>

                <button className="btn ripple btn-primary" onClick={this.onClickImportBranches}>
                    <i className="fe fe-plus-circle mr-1"></i> Import
                </button>
            </>
        )
    }

    onClickAdd = () => {
        this.props.history.push({
            pathname: '/config/branches/new'
        })
    }


    RenderBranches = () => {
        return (
            <ConfigurationConsumer>
                {props => {
                    const branchList = props.branchList
                    return (
                        // <div className="border-top overflow-auto">
                        <div className="table-responsive allView-config border-top">

                            {(branchList === "404") && <NoContent />}

                            {branchList && Array.isArray(branchList) &&
                                <table id="config-branches" className="table text-nowrap mb-0 table-hover datatable" export-format={eformats}>
                                    <thead>
                                        <tr>
                                            {/* <th>No.</th> */}
                                            <th>Branch Name</th>
                                            <th>Total Streets</th>
                                            <th>Total Locations</th>
                                            <th>Created at</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {branchList && branchList !== "404" &&
                                            branchList.map((item, key) =>
                                                <tr
                                                    id={"br_" + item.branch_id}
                                                    key={key}
                                                    className={`${this.state.branchId == item.branch_id ? 'flag-row' : ''}`}
                                                    onClick={() => this.onSelectBranch(item.branch_id, item)}
                                                >
                                                    {/* <td>{key + 1}</td> */}
                                                    <td>{item.branch_name}</td>
                                                    <td>{item.total_streets.total_c}</td>
                                                    <td>{item.total_locations.total_c}</td>
                                                    {/* <td>{item.lat !== null ? item.lat + ', ' + item.lng : ''}</td> */}
                                                    <td>
                                                        {item.created_at.date} <br />
                                                        <small className="tx-12 tx-gray-500">{item.created_at.time}</small>
                                                    </td>
                                                </tr>
                                            )
                                        }

                                    </tbody>

                                </table>
                            }

                            {!branchList && <ActivityLoader />}
                        </div>
                        // </div>
                    )
                }}
            </ConfigurationConsumer>
        )
    }


    onClickEdit = () => {

        if (this.state.branchRecord) {

            this.props.history.push({
                pathname: '/config/branches/edit',
                search: '?q=1',
                state: { record: this.state.branchRecord }
            })
        }

    }

    onClickDelete = () => {
        if (this.state.branchRecord) {
            $("#modal_delete").modal('show')
        }
    }

    onConfirmDelete = async () => {
        const { getBranches } = this.context;
        if (this.state.branchId) {
            $("#modal_delete").modal('hide');

            const server_response = await ajax.deleteBranch(this.state.branchId, this.state.userId);
            if (server_response.status === "OK") {
                this.setState({
                    toast: <Toast message={server_response.details.message} />
                }, () => {

                    //hide record
                    //Refresh list
                    getBranches();
                })
            } else {
                this.setState({
                    toast: <Toast message={server_response.details.message} />
                })
            }

        }

    }

    onSelectBranch = (branchId, branchRecord) => {
        this.setState({
            branchId: branchId,
            branchRecord: branchRecord,
            toast: ''
        })
    }


    RenderBranchCount = () => {
        return (
            <ConfigurationConsumer>
                {props => {
                    const countAllBranches = props.totalBranches
                    return (
                        <div className="text-wrap">
                            <div className="">
                                <div className="btn-list">

                                    <button type="button" className="btn ripple btn-primary btn-sm">
                                        Total Branches <span className="badge badge-light ml-2">{countAllBranches}</span>
                                    </button>

                                    <button className="btn ripple btn-light btn-sm" onClick={this.context.getBranches}>
                                        <i className="fa fa-redo mr-1"></i> Refresh
                                    </button>

                                </div>
                            </div>
                        </div>
                    )
                }}
            </ConfigurationConsumer>
        )
    }

    render() {
        return (
            <div className="page">

                <WarnDelete
                    title="Delete Branch?"
                    description="Make sure this branch has not streets and locations under it"
                    onConfirm={() => this.onConfirmDelete()} 
                />

                <LeftSideBar />
                
                <div className="main-content side-content pt-0" onClick={functions.closeSystemDrawer}>
                    <TopBar />
                    <div className="container-fluid">
                        <PageHeader
                            title="Branches"
                            previousPageTitle="Configurations"
                            back="/config"
                            buttons={<this.buttons />}
                            options={{
                                "add": () => this.onClickAdd(),
                                "edit": () => this.onClickEdit(),
                                "delete": () => this.onClickDelete()
                            }}
                        />

                        {this.state.toast}
                        {this.state.model}


                        <div className="row">
                            <div className="col-xl-9 col-lg-12">
                                <div className="row">


                                    <div className="col-sm-12 col-xl-12 col-lg-12">
                                        <div className="card custom-card">
                                            <div className="card-body">

                                                <div className="d-flex justify-content-between align-items-center filter-example">
                                                    <TableHeader
                                                        title="List Of Company Branches"
                                                        subtitle="List of all branches managed by Mutiplex parking"
                                                    />

                                                    <this.RenderBranchCount />
                                                </div>

                                                <this.RenderBranches />
                                            </div>
                                        </div>


                                    </div>


                                </div>

                            </div>

                            <ConfigMenu />



                        </div>


                    </div>
                </div>
                <RightSideBar />

            </div>


        );

    }
}

export default ConfigBranch
